export default "/images/externalLink.svg?04e65a6d94fbe635f80e2e429057218f";